export const API_LOGIN = "/admin/login";
export const API_LOGOUT = "/admin/logout";
export const API_GET_ADMIN_INFO = "/admin/userInfo";

// CINEFAN API
export const API_PAGES = "/cinefan/admin/pages";
export const API_HOMEPAGE = "/cinefan/admin/homepage";
export const API_GET_PAGE = (category) =>
  `/cinefan/admin/pages?unpaged=true&category=${category}`;

export const API_MOVIES = "/cinefan/admin/movies";
export const API_MOVIE = (id) => `/cinefan/admin/movies/${id}`;
export const API_MOVIES_BULK = "/cinefan/admin/movies/bulk";
export const API_MOVIES_TAGS = "/cinefan/admin/movies/tags";

export const API_REMARKS = "/cinefan/admin/movieremarks";
export const API_REMARK = (id) => `/cinefan/admin/movieremarks/${id}`;
export const API_REMARKS_BULK = "/cinefan/admin/movieremarks/bulk";

export const API_ROTATING_BANNERS = "/cinefan/admin/rotationbanner";
export const API_ROTATING_BANNER = (id) =>
  `/cinefan/admin/rotationbanner/${id}`;

export const API_TAGS = "/cinefan/admin/tag";
export const API_TAG = (id) => `/cinefan/admin/tag/${id}`;
export const API_TAGS_BULK = "/cinefan/admin/tag/bulk";
export const API_NOTE = `/cinefan/admin/movienote`;

export const API_UPLOAD = "/cinefan/admin/file";

export const API_PERIOD = "/cinefan/admin/period";
export const API_PARENT_PERIOD = "/cinefan/admin/period/parent-period";
export const API_PERIOD_BULK = "/cinefan/admin/period/bulk";
export const API_MENU = "/cinefan/admin/menu";

export const API_PROGRAMME = "/cinefan/admin/programme";
export const API_PROGRAMMEBYID = (id) => `/cinefan/admin/programme/${id}`;
export const API_ADMIN = "/permission/users";
export const API_ROLES = "/permission/roles";

export const API_OPTION = "/cinefan/admin/option";

export const API_PAGE_IMPORT_FILE = "/cinefan/admin/pages/import";
export const API_PAGE_IMPORT_IMAGE = "/cinefan/admin/pages/import-image";

export const API_MOVIE_IMPORT_FILE = "/cinefan/admin/movies/import";
export const API_MOVIE_IMPORT_IMAGE = "/cinefan/admin/movies/import-image";

// HKIFF API
export const API_HKIFF_BANNER = "/hkiff/admin/banner";
export const API_HKIFF_EDM = "/hkiff/admin/news-letter";
export const API_HKIFF_FESTIVAL = "/hkiff/admin/news";
export const API_HKIFF_NEWS = "/hkiff/admin/news";
export const API_HKIFF_SPONSOR = "/hkiff/admin/sponsor";
export const API_HKIFF_SPONSOR_CATEGORY = "/hkiff/admin/sponsor/category";
export const API_HKIFF_SUBSCRIBE = "/hkiff/admin/subscribe";
export const API_ENTRIES_APPLICATIONS = "/hkiff/admin/entries/applications";
export const API_INVITED_ENTRIES = "/hkiff/admin/entries/invited-entry";
export const API_GUEST_ACCREDITATION = "/hkiff/admin/guest-accreditation";
export const API_HISTORY_CULTURE = "/hkiff/admin/history-culture";
export const API_COMPANY = "/hkiff/admin/company";
export const API_CONTACT_US = "/hkiff/admin/contactus";
export const API_SUPPORT_US = "/hkiff/admin/support-us";
export const API_ORGANIZATION = "/hkiff/admin/organization";
export const API_POSITION = "/hkiff/admin/position";
export const API_EMPLOYEE = "/hkiff/admin/employee";
export const API_MEDIA_ACCREDITATION = "/hkiff/admin/media-accreditation";
export const API_HKIFF_CONFIG = "/hkiff/admin/entries/configs/email/settings";
export const API_HKIFF_TEMPLATE = "/hkiff/admin/entries/configs/email/template";
export const API_GUEST_TEMPLATE =
  "/hkiff/admin/guest-accreditation/configs/email/template";
export const API_MEDIA_TEMPLATE =
  "/hkiff/admin/media-accreditation/configs/email/template";
export const API_REFUND_FORM_PROGRAMMES = "/hkiff/admin/refund-form/programmes";
export const API_REFUND_FORM_VENUES = "/hkiff/admin/refund-form/venues";
export const API_REFUND_FORM_EMAIL_CONFIG =
  "/hkiff/admin/refund-form/configs/email/template";
export const API_REFUND_FORM_TNC =
  "/hkiff/admin/refund-form/configs/email/settings";
export const API_REFUND_FORM_APP = "/hkiff/admin/refund-form/forms";
export const API_MEMBERS = "/membership/admin/members";
export const API_ORDERS = "/membership/admin/orders";
export const API_GIFT = "/membership/admin/gift";
export const API_PLAN = "/membership/admin/plan";
export const API_CONFIG = "/membership/admin/config";
export const API_EMAIL = "/membership/admin/email/template";
export const API_MEMBER_IMPORT_FILE = "/membership/admin/members/excelImport";
export const API_FESTIVAL_PASS = "/hkiff/admin/festivalpass";
export const API_TICKETING = "/hkiff/admin/ticketing";
export const API_FILM_CATEGORY = "/hkiff/admin/film/category";
export const API_FILM_SUBCATEGORY = "/hkiff/admin/film/subcategory";
export const API_FILM = "/hkiff/admin/film";
export const API_FILM_TAG = "/hkiff/admin/film/tab";
export const API_FILM_ICON = "/hkiff/admin/film-icon";
export const API_HKIFF_VENUE = "/hkiff/admin/region/venue";
export const API_HKIFF_REGION = "/hkiff/admin/region/region";
export const API_HKIFF_DISTRICT = "/hkiff/admin/region/district";
export const API_JURY = "/hkiff/admin/jury";

export const API_HKIFF_PRODUCT_CATEGORY = "/hkiff/admin/product-category";
export const API_HKIFF_PRODUCT = "/hkiff/admin/product";
export const API_HKIFF_PRODUCT_TAG = "/hkiff/admin/tag";
export const API_HKIFF_EVENT = "/hkiff/admin/event";

export const API_FILM_IMPORT_FILE = "/hkiff/admin/film/import";
export const API_FILM_IMPORT_IMAGE = "/hkiff/admin/film/import-image";

export const API_HKIFF_PROGRAMME = "/hkiff/admin/programme";
export const API_HKIFF_PROGRAMME_CATEGORY = "/hkiff/admin/programme-category";
export const API_HKIFF_PROGRAMME_TYPE = "/hkiff/admin/programme/programme-type";
export const API_HKIFF_PROGRAMME_SCREENING_CODE =
  "/hkiff/admin/programme/screeningCode";

export const API_HKIFF_MENU = "/hkiff/admin/web-menu";
export const API_HKIFF_EVENT_CATEGORY = "/hkiff/admin/event-category";

export const API_HKIFF_AWARD_CATEGORY = "/hkiff/admin/award-category";
export const API_HKIFF_AWARD = "/hkiff/admin/award";

export const API_HKIFF_UPLOAD = (folder = "HKIFF") =>
  `/hkiff/admin/file/${folder}`;

export const API_HKIFF_TRANSACTION_EMAIL = "/hkiff/admin/transaction-email";

export const API_HKIFF_TRANSACTION = "/hkiff/admin/transaction";
export const API_HKIFF_TRANSACTION_ORDER_STATUS =
  "/hkiff/admin/transaction/order-status";

export const API_HKIFF_JOB = "/hkiff/admin/jobOpportunity";
export const API_HKIFF_PAGE_WORD = "/hkiff/admin/page-words";

export const API_HKIFF_LOGO = "/hkiff/admin/using-our-logos";
export const API_HKIFF_REPORT = "/hkiff/admin/report";
export const API_HKIFF = "/hkiff/admin/hkiff";
export const API_SHIPPING = "/hkiff/admin/shipping";

export const API_HKIFF_ESHOP = "/hkiff/admin/eshop-setting";
export const API_HKIFF_SCORE_BOARD = "/hkiff/admin/aca/score-board";
export const API_HKIFF_ACA_FILM_LIST = "/hkiff/admin/aca/film-list";
export const API_ACA_FILM_IMPORT_FILE = "/hkiff/admin/aca/import";
export const API_HKIFF_ACA_BANNER = "/hkiff/admin/aca/banner";
export const API_HKIFF_ACA_SETTING = "/hkiff/admin/aca/setting";

// HKIFF APP API
export const API_HKIFF_APP = (category) =>
  `/hkiff/admin/app/options/${category}`;
export const API_HKIFF_APP_MENU = "/hkiff/admin/app/menu";
export const API_HKIFF_APP_BANNER = "/hkiff/admin/app/banner";

//HKNT API
export const API_HKNT_PAGES = "/hknt/admin/pages";
export const API_HKNT_HOMEPAGE = "/hknt/admin/homepage";
export const API_HKNT_GET_PAGE = (category) =>
  `/hknt/admin/pages?unpaged=true&category=${category}`;

export const API_HKNT_MOVIES = "/hknt/admin/movies";
export const API_HKNT_MOVIE = (id) => `/hknt/admin/movies/${id}`;
export const API_HKNT_MOVIES_BULK = "/hknt/admin/movies/bulk";
export const API_HKNT_MOVIES_TAGS = "/hknt/admin/movies/tags";

export const API_HKNT_REMARKS = "/hknt/admin/movieremarks";
export const API_HKNT_REMARK = (id) => `/hknt/admin/movieremarks/${id}`;
export const API_HKNT_REMARKS_BULK = "/hknt/admin/movieremarks/bulk";

export const API_HKNT_ROTATING_BANNERS = "/hknt/admin/rotationbanner";
export const API_HKNT_ROTATING_BANNER = (id) =>
  `/hknt/admin/rotationbanner/${id}`;

export const API_HKNT_TAGS = "/hknt/admin/tag";
export const API_HKNT_TAG = (id) => `/hknt/admin/tag/${id}`;
export const API_HKNT_TAGS_BULK = "/hknt/admin/tag/bulk";
export const API_HKNT_NOTE = `/hknt/admin/movienote`;

export const API_HKNT_UPLOAD = "/hknt/admin/file";

export const API_HKNT_PERIOD = "/hknt/admin/period";
export const API_HKNT_PARENT_PERIOD = "/hknt/admin/period/parent-period";
export const API_HKNT_PERIOD_BULK = "/hknt/admin/period/bulk";
export const API_HKNT_MENU = "/hknt/admin/menu";

export const API_HKNT_PROGRAMME = "/hknt/admin/programme";
export const API_HKNT_PROGRAMMEBYID = (id) => `/hknt/admin/programme/${id}`;
export const API_HKNT_ADMIN = "/permission/users";
export const API_HKNT_ROLES = "/permission/roles";

export const API_HKNT_OPTION = "/hknt/admin/option";

export const API_HKNT_PAGE_IMPORT_FILE = "/hknt/admin/pages/import";
export const API_HKNT_PAGE_IMPORT_IMAGE = "/hknt/admin/pages/import-image";

export const API_HKNT_MOVIE_IMPORT_FILE = "/hknt/admin/movies/import";
export const API_HKNT_MOVIE_IMPORT_IMAGE = "/hknt/admin/movies/import-image";
